import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "SharedComponents/ScrollToTop";

import { useSelector } from "react-redux";
import PageForbidden from "SharedComponents/403";
import PageNotFound from "SharedComponents/404";
import HomeLayout from "Layouts/HomeLayout";
import HotelLayout from "Layouts/HotelLayout";
import Dashboardpage from "Pages/Dashboard";
import ProfileSettings from "Pages/Profile/ProfileSettings";
import AvailableBanks from "Pages/Availablebanks"
import Accounttypes from "Pages/Accounttypes"

import DashboardHotel from "Pages/DashboardHotel";
import MytripsHotel from "Pages/MytripsHotel";
import UpcomingtripsHotel from "Pages/UpcomingtripsHotel";

import Dashboardcorporate from "Pages/DashboardCorporate";
import Corporategroup from "Pages/Corporategroup";
import CorporateEmployee from "Pages/CorporateEmployee";
import OverallreportCorp from "Pages/OverallreportCorp"
import DailyreportCorp from "Pages/DailyreportCorp"
import MontlyreportCorp from "Pages/MontlyreportCorp"
import YearlyreportCorp from "Pages/YearlyreportCorp"

// Settings Route
import Settings from "Pages/Profile/Settings";
import SiteSettings from "Pages/Settings/SiteSettings";
import PaymentSettings from "Pages/Settings/PaymentSettings";
import PlatformfeeSettings from "Pages/Settings/PlatformfeeSettings";
import UserrewardSettings from "Pages/Settings/UserrewardSettings";
import BusinessSettings from "Pages/Settings/BusinessSettings";
import ChangePassword from "Pages/Settings/ChanagePassword";
import LegalSettings from "Pages/Settings/LegalSettings";
import Termsandcondition from "Pages/Settings/Termsandcondition"
import PrivacyPolicy from "Pages/Settings/PrivacyPolicy"

// Icons
import { Dashboard , PersonAddAlt1 ,Photo, LocalTaxi, Discount , AssignmentInd,  
  SettingsSuggest, EmojiTransportation , 
  History , Assessment , Wallet , RateReview , MoneyOffCsredOutlined , AttachMoney , BalanceTwoTone,DirectionsCar } from "@mui/icons-material";


import AddLocation from "Pages/ZoneManagement/AddLocation";
import ListLocation from "Pages/ZoneManagement/ListLocation";
import RestrictLocation from "Pages/ZoneManagement/RestrictLocation";
import Passenger from "Pages/Passenger";
import TestPage from "Pages/TestPage";
import Driver from "Pages/Driver";
import Ride from "Pages/Ride";
import RideWaypoint from "Pages/RideWaypoint";
import Booking from "Pages/Booking";
import Conversation from "Pages/Conversation";
import Messages from "Pages/Messages";
import Reviews from "Pages/Reviews";
import BusRoutes from "Pages/BusRoutes";
import BusTrip from "Pages/BusTrip";
import Place from "Pages/Place";
import Dispatcher from "Pages/Dispatcher";
import Accountmanager from "Pages/Accountmanager";
import Subcompany from "Pages/Subcompany";
import Corporate from "Pages/Corporate";
import Hotel from "Pages/Hotel";
import Userwallet from "Pages/Userwallet";
import Userwalletlogs from "Pages/Userwalletlogs";
import Driverwallet from "Pages/Driverwallet";
import Driverrewards from "Pages/Driverreward";
import Driverearnings from "Pages/Driverearnings";
import Driverearningslogs from "Pages/Driverearningslogs";
import Driverrewardlogs from "Pages/Driverrewardlogs";
import Promocodes from "Pages/Promocodes"
import Cashoutrecords from "Pages/Cashoutrecords";
import Cashoutrejected from "Pages/Cashoutrejected";
import Cashoutapproved from "Pages/Cashoutapproved";
import Cashoutsheets from "Pages/Cashoutsheets";
import Driverwalletlogs from "Pages/Driverwalletlogs";
import Servicetype from "Pages/ServiceType";
import BannerTemplateManage from "Pages/BannerTemplateManage";
import Servicetypefare from "Pages/Servicetypefare"
import ServicetypeZonefare from "Pages/ServicetypeZonefare"
import PassengerHistory from "Pages/Passengerhistory"
import Overallreport from "Pages/Overallreport"
import Kmdrivendurationreport from 'Pages/kmdrivendurationreport'
import Driversreport from "Pages/Driversreport"
import Driverreport from "Pages/Driversreport/Driverreport"
import KMdriverreport from "Pages/kmdrivendurationreport/Driverreport"
import Triplist from "Pages/Triplisttwo"
import TriplistPassenger from "Pages/TriplistPassenger"
import TripEnterprise from "Pages/TrajetEnterprise"
import DispatcherPassenger from "Pages/DispatcherPassenger"
import TripDriver from "Pages/TripDriver"
import Dispatcherpanel from "Pages/Dispatcherpanel"
import Smsnotifications from "Pages/Smsnotifications"
import Mailnotifications from "Pages/Mailnotifications"
import Pushnotifications from "Pages/Pushnotifications"
import Userratings from "Pages/Userratings";
import Driverratings from "Pages/Driverratings";
import Vehicle from "Pages/Vehicle";
import Foundation from "Pages/foundation";
import HomeRide from "../Pages/HomeRide";
import HomeRideDetails from "../Pages/HomeRideDetails";
import BookingConfirmation from "../Pages/BookingConfirmation";
import DashboardClient from "../Pages/DashboardClient";
import DashboardDriver from "../Pages/DashboardDriver";
import Trajet from "../Pages/Trajet";
import CourseDriver from "../Pages/CourseDriver";
import CourseEnterprise from "../Pages/CourseEnterprise";
import TrajetDriver from "../Pages/TrajetDriver";
import TrajetClient from "../Pages/TrajetClient";
import HistoriqueClient from "../Pages/HistoriqueClient";
import PaiementsClient from "../Pages/PaiementsClient";
import WalletClient from "../Pages/WalletClient";
import FavorisClient from "../Pages/FavorisClient";
import ProfileClient from "../Pages/ProfileClient";
import ParametreClient from "../Pages/ParametreClient";
import SettingsClient from "../Pages/SettingsClient";
import SecurityClient from "../Pages/SecurityClient";
import NotificationsClient from "../Pages/NotificationsClient";
import PaypalApproved from "../Pages/PaypalApproved";
import PaiementCancel from "../Pages/PaiementCancel";
import All from "../Pages/All/All";
import AllRider from "../Pages/All/AllRider";
import AllMetuaaEat from "../Pages/All/AllMetuaaEat";
import AllMetuaaTravelHub from "../Pages/All/AllMetuaaTravelHub";
import AllMetuaaBuy from "../Pages/All/AllMetuaaBuy";
import AllMetuaa from "../Pages/All/AllMetuaa";
import AllDriver from "../Pages/All/AllDriver";
import SignUpPassenger from "../Pages/All/SignUpPassenger";
import SignUpDriverV2 from "../Pages/All/SignUpDriverV2";
import MPlusProgram from "../Pages/All/MPlusProgram";
import SignUpEntreprise from "../Pages/All/SignUpEntreprise/signUpEntreprise";
import SignUpBusiness from "../Pages/All/SignUpBusiness";
import SigninAll from "../Pages/All/SigninAll";
import AllEnterprise from "../Pages/All/AllEnterprise";
import AllMappers from "../Pages/All/AllMappers";
import DashboardClientLayout from "../Layouts/DashboardClientLayout";
import DashboardDriverLayout from "../Layouts/DashboardDriverLayout";
import ProfileDriver from "../Pages/ProfileDriver";
import WalletDriver from "../Pages/WalletDriver";
import SettingsDriver from "../Pages/SettingsDriver";
import DashboardEntrepriseLayout from "../Layouts/DashboardEntrepriseLayout";
import DashboardEntreprise from "../Pages/DashboardEntreprise";
import CorporateVehicle from "../Pages/CorporateVehicle";
import DriverVehicle from "../Pages/DriverVehicle";
import DriverVehicleAssignments from "../Pages/DriverVehicleAssignments";
import CorporateDriver from "../Pages/CorporateDriver";
import WalletEntreprise from "../Pages/WalletEntreprise";
import ProfileEntreprise from "../Pages/ProfileEntreprise";

const Router = () => {
  const isAuthenticated = useSelector(
    (state) => state?.AuthReducer?.isAuthenticated || false
  );
  const userType = useSelector(
    (state) => state?.AuthReducer?.userType || ""
  );
  const PrivateRoute = ({ children, icon, label, noPadding }) => {
    if (isAuthenticated) {
      return (
        <>
          <HomeLayout
            children={children}
            icon={icon}
            label={label}
            noPadding={noPadding}
          />
        </>
      );
    } else return <Navigate to="/" />;
  };

  const PrivateRoutePassenger = ({ children, icon, label, noPadding,activeSidebarLabel }) => {
   
    if (isAuthenticated) {
      return (
        <>
          <DashboardClientLayout
            children={children}
            icon={icon}
            label={label}
            noPadding={noPadding}
            activeSidebarLabel={activeSidebarLabel}
          />
        </>
      );
    } else return <Navigate to="/" />;
  };

  const PrivateRouteDriver = ({
    children,
    icon,
    label,
    noPadding,
    activeSidebarLabel,
    sidebarTheme,
  }) => {
   
    if (isAuthenticated) {
      return (
        <>
          <DashboardDriverLayout
            children={children}
            icon={icon}
            label={label}
            noPadding={noPadding}
            activeSidebarLabel={activeSidebarLabel}
            sidebarTheme={sidebarTheme}
          />
        </>
      );
    } else return <Navigate to="/" />;
  };

  const PrivateRouteEntreprise = ({
    children,
    icon,
    label,
    noPadding,
    activeSidebarLabel,
    sidebarTheme,
  }) => {
   
    if (isAuthenticated) {
      return (
        <>
          <DashboardEntrepriseLayout
            children={children}
            icon={icon}
            label={label}
            noPadding={noPadding}
            activeSidebarLabel={activeSidebarLabel}
            sidebarTheme={sidebarTheme}
          />
        </>
      );
    } else return <Navigate to="/" />;
  };

const HotelPrivateRoute = ({ children, icon, label, noPadding }) => {
  if (isAuthenticated) {

    return (
     <HotelLayout icon={icon} label={label} noPadding={noPadding}>
        {children}
      </HotelLayout>
    );
  } else return <Navigate to="/" />;
};

  const HomeRoute = () => {
   
    if (isAuthenticated) {
      if(userType === "CORPORATE"){
         return <Navigate replace to="/dashboard-entreprise" />;
      }
      if(userType === "HOTEL"){
        return <Navigate replace to="/dashboard_hotel" />
      }
      if(userType === "USER"){
        return <Navigate replace to="/dashboard-client" />
      }
      if(userType === "DRIVER"){
        return <Navigate replace to="/dashboard-driver" />
      }
      return <Navigate replace to="/" />;
    } else return <All />;
  };

  return (
    <BrowserRouter>
      <ScrollToTop>
        <Routes>
<Route path="/" element={<HomeRoute />} />
<Route path="/login" element={<SigninAll />} />
<Route path="/home-ride" element={<HomeRide />} />
<Route path="/home-ride-details" element={<HomeRideDetails />} />
<Route path="/all" element={<All />} />
<Route path="/metuaa-travel-hub" element={<AllMetuaaTravelHub />} />
<Route path="/metuaa-mapper" element={<AllMappers/>} />
<Route path="/metuaa" element={<AllMetuaa />} />
<Route path="/all-ride" element={<AllRider />} />
<Route path="/metuaa-eat" element={<AllMetuaaEat />} />
<Route path="/metuaa-buy" element={<AllMetuaaBuy />} />
<Route path="/all-drive" element={<AllDriver />} />
<Route path="/all-driver" element={<AllDriver />} />
<Route path="/signup-passenger" element={<SignUpPassenger />} />
<Route path="/signup-driver" element={<SignUpDriverV2 />} />
<Route path="/signup-driver-v2" element={<SignUpDriverV2 />} />
<Route path="/mplus-program" element={<MPlusProgram />} />
<Route path="/signup-entreprise" element={<SignUpEntreprise />} />
<Route path="/signup-business" element={<SignUpBusiness />} />
<Route path="/signin-all" element={<SigninAll />} />
<Route path="/all-enterprise" element={<AllEnterprise />} />
<Route path="/all-entreprise" element={<AllEnterprise />} />
<Route path="/paiement-success" element={<PaypalApproved />} />
<Route path="/paiement-sucess" element={<PaypalApproved />} />
<Route path="/payment-success" element={<PaypalApproved />} />
<Route path="/paypal-approved" element={<PaypalApproved />} />
<Route path="/paiement-cancel" element={<PaiementCancel />} />
<Route path="/paiement-annule" element={<PaiementCancel />} />
<Route path="/payment-cancel" element={<PaiementCancel />} />
<Route path="/paypal-cancel" element={<PaiementCancel />} />



<Route path="/dashboard-client" element={<PrivateRoutePassenger activeSidebarLabel={"Tableau de bord"}><DashboardClient /></PrivateRoutePassenger>} />
<Route path="/trajet" element={<PrivateRoutePassenger activeSidebarLabel={"Mes reservations"}><Trajet /></PrivateRoutePassenger>} />
<Route path="/trajet-client" element={<PrivateRoutePassenger activeSidebarLabel={"Mes rÃ©servations"}><TrajetClient /></PrivateRoutePassenger>} />
<Route path="/historique-client" element={<PrivateRoutePassenger activeSidebarLabel={"Historique"}><HistoriqueClient /></PrivateRoutePassenger>} />
<Route path="/paiements-client" element={<PrivateRoutePassenger activeSidebarLabel={"Mes transactions"}><PaiementsClient /></PrivateRoutePassenger>} />
<Route path="/wallet-client" element={<PrivateRoutePassenger activeSidebarLabel={"Wallet"}><WalletClient /></PrivateRoutePassenger>} />
<Route path="/favoris-client" element={<PrivateRoutePassenger activeSidebarLabel={"Favoris"}><FavorisClient /></PrivateRoutePassenger>} />
<Route path="/profile-client" element={<PrivateRoutePassenger activeSidebarLabel={"Profil"}><ProfileClient /></PrivateRoutePassenger>} />
<Route path="/parametres-client" element={<PrivateRoutePassenger activeSidebarLabel={"ParamÃ¨tres"}><ParametreClient /></PrivateRoutePassenger>} />
<Route path="/settings-client" element={<PrivateRoutePassenger activeSidebarLabel={"Settings"}><SettingsClient /></PrivateRoutePassenger>} />
<Route path="/securite-client" element={<PrivateRoutePassenger activeSidebarLabel={"SÃ©curitÃ©"}><SecurityClient /></PrivateRoutePassenger>} />
<Route path="/notifications-client" element={<PrivateRoutePassenger activeSidebarLabel={"Notifications"}><NotificationsClient /></PrivateRoutePassenger>} />
<Route path="/booking-confirmation" element={<PrivateRoutePassenger activeSidebarLabel={"Mes confirmations"}><BookingConfirmation /></PrivateRoutePassenger>} />
<Route path="/dispatcher-passenger" element={<PrivateRoutePassenger activeSidebarLabel={"Courses"}><DispatcherPassenger /></PrivateRoutePassenger>} />
<Route path="/trip-list-passenger" element={<PrivateRoutePassenger activeSidebarLabel={"Mes courses"}><TriplistPassenger /></PrivateRoutePassenger>} />




<Route path="/dashboard-driver" element={<PrivateRouteDriver activeSidebarLabel={"dashboard.layout.sidebar.home"} sidebarTheme="dashboard-driver"><DashboardDriver /></PrivateRouteDriver>} />
<Route path="/profile-driver" element={<PrivateRouteDriver activeSidebarLabel={"dashboard.layout.sidebar.profile"}  sidebarTheme="dashboard-driver"><ProfileDriver /></PrivateRouteDriver>} />
<Route path="/course-driver" element={<PrivateRouteDriver activeSidebarLabel={"dashboard.layout.sidebar.myCourses"} sidebarTheme="dashboard-driver"><CourseDriver /></PrivateRouteDriver>} />
<Route path="/trajet-driver" element={<PrivateRouteDriver activeSidebarLabel={"dashboard.layout.sidebar.myTrips"} sidebarTheme="dashboard-driver"><TrajetDriver /></PrivateRouteDriver>} />
<Route path="/driver-vehicle" element={<PrivateRouteDriver activeSidebarLabel={"dashboard.layout.sidebar.myVehicle"} sidebarTheme="dashboard-driver"><DriverVehicle /></PrivateRouteDriver>} />
<Route path="/driver-vehicle-assignments" element={<PrivateRouteDriver activeSidebarLabel={"driver.vehicle.assignments"} sidebarTheme="dashboard-driver"><DriverVehicleAssignments /></PrivateRouteDriver>} />
{/* <Route path="/trip-driver" element={<PrivateRouteDriver activeSidebarLabel={"Historique trips"} sidebarTheme="dashboard-driver"><TripDriver /></PrivateRouteDriver>} /> */}
<Route path="/wallet-driver" element={<PrivateRouteDriver activeSidebarLabel={"dashboard.layout.sidebar.wallet"} sidebarTheme="dashboard-driver"><WalletDriver /></PrivateRouteDriver>} />
<Route path="/settings-driver" element={<PrivateRouteDriver activeSidebarLabel={"dashboard.layout.sidebar.settings"} sidebarTheme="dashboard-driver"><SettingsDriver /></PrivateRouteDriver>} />


<Route path="/dashboard-entreprise" element={<PrivateRouteEntreprise activeSidebarLabel={"Tableau de bord"} sidebarTheme="dashboard-driver"><DashboardEntreprise /></PrivateRouteEntreprise>} />
{/* <Route path="/corporate-group" element={<PrivateRouteEntreprise activeSidebarLabel={"Groupes"} sidebarTheme="dashboard-driver"><Corporategroup /></PrivateRouteEntreprise>} /> */}
{/* <Route path="/corporate-employee" element={<PrivateRouteEntreprise activeSidebarLabel={"EmployÃ©s"} sidebarTheme="dashboard-driver"><CorporateEmployee /></PrivateRouteEntreprise>} /> */}
<Route path="/corporate-vehicles" element={<PrivateRouteEntreprise activeSidebarLabel={"VÃ©hicules"} sidebarTheme="dashboard-driver"><CorporateVehicle /></PrivateRouteEntreprise>} />
<Route path="/corporate-drivers" element={<PrivateRouteEntreprise activeSidebarLabel={"Conducteurs"} sidebarTheme="dashboard-driver"><CorporateDriver /></PrivateRouteEntreprise>} />
<Route path="/corporate-rides" element={<PrivateRouteEntreprise activeSidebarLabel={"Voyages"} sidebarTheme="dashboard-driver"><TripEnterprise /></PrivateRouteEntreprise>} />
<Route path="/corporate-courses" element={<PrivateRouteEntreprise activeSidebarLabel={"RÃ©servations"} sidebarTheme="dashboard-driver"><CourseEnterprise /></PrivateRouteEntreprise>} />
<Route path="/wallet-entreprise" element={<PrivateRouteEntreprise activeSidebarLabel={"wallet"} sidebarTheme="dashboard-driver"><WalletEntreprise /></PrivateRouteEntreprise>} />
<Route path="/profile-entreprise" element={<PrivateRouteEntreprise activeSidebarLabel={"Profil"} sidebarTheme="dashboard-driver"><ProfileEntreprise /></PrivateRouteEntreprise>} />
<Route path="/overallreport-corp" element={<PrivateRouteEntreprise activeSidebarLabel={"Rapports"} sidebarTheme="dashboard-driver"><OverallreportCorp /></PrivateRouteEntreprise>} />
<Route path="/driver-assignments" element={<PrivateRouteEntreprise activeSidebarLabel={"Driver Assignments"} sidebarTheme="dashboard-driver"><DriverVehicleAssignments /></PrivateRouteEntreprise>} />

 
<Route path="/dashboard" element={<PrivateRoute><Dashboardpage /></PrivateRoute>} />
<Route path="/add-location" element={<PrivateRoute icon={<PersonAddAlt1 />} label={"Add Location"}><AddLocation /></PrivateRoute>} />
<Route path="/list-location" element={<PrivateRoute icon={<PersonAddAlt1 />} label={"List Location"}><ListLocation /></PrivateRoute>} />
<Route path="/restrict-location" element={<PrivateRoute icon={<PersonAddAlt1 />} label={"Restrict Location"}><RestrictLocation /></PrivateRoute>} />
<Route path="/passenger" element={<PrivateRoute icon={<PersonAddAlt1 />} label={"Passenger"}><Passenger /></PrivateRoute>} />
<Route path="/driver" element={<PrivateRoute icon={<PersonAddAlt1 />} label={"Driver"}><Driver /></PrivateRoute>} />
<Route path="/place" element={<PrivateRoute icon={<PersonAddAlt1 />} label={"Place"}><Place /></PrivateRoute>} />
<Route path="/ride" element={<PrivateRoute icon={<PersonAddAlt1 />} label={"Ride"}><Ride /></PrivateRoute>} />
<Route path="/ride-waypoint" element={<PrivateRoute icon={<PersonAddAlt1 />} label={"Ride Waypoint"}><RideWaypoint /></PrivateRoute>} />
<Route path="/booking" element={<PrivateRoute icon={<PersonAddAlt1 />} label={"Booking"}><Booking /></PrivateRoute>} />
<Route path="/conversations" element={<PrivateRoute icon={<PersonAddAlt1 />} label={"Conversations"}><Conversation /></PrivateRoute>} />
<Route path="/messages" element={<PrivateRoute icon={<PersonAddAlt1 />} label={"Messages"}><Messages /></PrivateRoute>} />
<Route path="/reviews" element={<PrivateRoute icon={<PersonAddAlt1 />} label={"Reviews"}><Reviews /></PrivateRoute>} />
<Route path="/bus-routes" element={<PrivateRoute icon={<PersonAddAlt1 />} label={"Bus Routes"}><BusRoutes /></PrivateRoute>} />
<Route path="/bus-trip" element={<PrivateRoute icon={<PersonAddAlt1 />} label={"Bus Trip"}><BusTrip /></PrivateRoute>} />
<Route path="/dispatcher" element={<PrivateRoute icon={<PersonAddAlt1 />} label={"Dispatcher"}><Dispatcher /></PrivateRoute>} />
<Route path="/account-manager" element={<PrivateRoute icon={<PersonAddAlt1 />} label={"Account manager"}><Accountmanager /></PrivateRoute>} />
<Route path="/sub-company" element={<PrivateRoute icon={<PersonAddAlt1 />} label={"Sub company"}><Subcompany /></PrivateRoute>} />
<Route path="/hotel" element={<PrivateRoute icon={<PersonAddAlt1 />} label={"Hotel/restaurant"}><Hotel /></PrivateRoute>} />
<Route path="/corporate" element={<PrivateRoute icon={<PersonAddAlt1 />} label={"Corporate"}><Corporate /></PrivateRoute>} />
<Route path="/servicetype" element={<PrivateRoute icon={<LocalTaxi />} label={"Service type"}><Servicetype /></PrivateRoute>} />
<Route path="/BannerTemplateManage" element={<PrivateRoute icon={<Photo />} label={"Banner Template Management"}><BannerTemplateManage /></PrivateRoute>} />
<Route path="/servicetypefare" element={<PrivateRoute icon={<EmojiTransportation />} label={"Service Type Fare"}><Servicetypefare /></PrivateRoute>} />
<Route path="/ServicetypeZonefare" element={<PrivateRoute icon={<EmojiTransportation />} label={"Service Type ZoneBased Fare"}><ServicetypeZonefare /></PrivateRoute>} />
<Route path="/passengerhistory" element={<PrivateRoute icon={<History />} label={"Request History"}><PassengerHistory /></PrivateRoute>} />
<Route path="/triplist" element={<PrivateRoute noPadding><Triplist /></PrivateRoute>} />
<Route path="/trip-list-passenger" element={<PrivateRoute><TriplistPassenger /></PrivateRoute>} />
<Route path="/dispatcher-passenger" element={<PrivateRoute noPadding><DispatcherPassenger /></PrivateRoute>} />
<Route path="/dispatcherpanel" element={<PrivateRoute noPadding><Dispatcherpanel /></PrivateRoute>} />
{/* <Route path="/triplist" element={<Triplist />} /> */}
<Route path="/overallreport" element={<PrivateRoute icon={<Assessment />} label={"Overall Report"}><Overallreport /></PrivateRoute>} />
<Route path="/driversreport" element={<PrivateRoute icon={<Assessment />} label={"Drivers Statement"}><Driversreport /></PrivateRoute>} />
<Route path="/driverreport" element={<PrivateRoute icon={<Assessment />} label={"Driver Statement"}><Driverreport /></PrivateRoute>} />
<Route path="/kmdriven-duration-report" element={<PrivateRoute icon={<Assessment />} label={"Km Driven / Duration Report"}><Kmdrivendurationreport /></PrivateRoute>} />
<Route path="/kmdriverreport" element={<PrivateRoute icon={<Assessment />} label={"Km Driven / Duration Statement"}><KMdriverreport /></PrivateRoute>} />
<Route path="/user-wallet" element={<PrivateRoute icon={<Wallet />} label={"User Rewards"}><Userwallet /></PrivateRoute>} />
<Route path="/user-wallet-logs/:id/:user_id" element={<PrivateRoute> <Userwalletlogs /></PrivateRoute>} />
<Route path="/user-reward-settings" element={<PrivateRoute icon={<AssignmentInd />} label={"User reward Settings"}><UserrewardSettings /></PrivateRoute>} />
<Route path="/driver-wallet" element={<PrivateRoute icon={<Wallet />} label={"Driver Wallet"}><Driverwallet /></PrivateRoute>} />
<Route path="/driver-wallet-logs/:id/:user_id" element={<PrivateRoute> <Driverwalletlogs /></PrivateRoute>} />
<Route path="/smsnotifications" element={<PrivateRoute ><Smsnotifications /></PrivateRoute>} />
<Route path="/mailnotifications" element={<PrivateRoute ><Mailnotifications /></PrivateRoute>} />
<Route path="/pushnotifications" element={<PrivateRoute ><Pushnotifications /></PrivateRoute>} />
<Route path="/userratings" element={<PrivateRoute icon={<RateReview />} label={"User rating"}><Userratings /></PrivateRoute>} />
<Route path="/driverratings" element={<PrivateRoute icon={<RateReview />} label={"Driver rating"}><Driverratings /></PrivateRoute>} />
<Route path="/vehicle" element={<PrivateRoute icon={<DirectionsCar />} label={"Vehicles"}><Vehicle /></PrivateRoute>} />
<Route path="/driver-rewards" element={<PrivateRoute icon={<MoneyOffCsredOutlined />} label={"Driver Rewards"}><Driverrewards /></PrivateRoute>} />
<Route path="/driver-reward-logs/:id" element={<PrivateRoute> <Driverrewardlogs /></PrivateRoute>} />
<Route path="/driver-earnings" element={<PrivateRoute icon={<MoneyOffCsredOutlined />} label={"Driver Earnings"}><Driverearnings /></PrivateRoute>} />
<Route path="/driver-earning-logs/:id" element={<PrivateRoute> <Driverearningslogs /></PrivateRoute>} />
<Route path="/cashoutrecords" element={<PrivateRoute icon={<AttachMoney />} label={"Cashout records"}><Cashoutrecords /></PrivateRoute>} />
<Route path="/cashoutsapproved" element={<PrivateRoute icon={<AttachMoney />} label={"Cashouts approved"}><Cashoutapproved /></PrivateRoute>} />
<Route path="/cashoutsrejected" element={<PrivateRoute icon={<AttachMoney />} label={"Cashout rejected"}><Cashoutrejected /></PrivateRoute>} />
<Route path="/cashoutsheets" element={<PrivateRoute icon={<AttachMoney />} label={"Cashout sheets"}><Cashoutsheets /></PrivateRoute>} />
<Route path="/admin-commission-settings" element={<PrivateRoute icon={<AssignmentInd />} label={"Admin Commission Settings"}><PlatformfeeSettings /></PrivateRoute>} />

<Route path="/account-type-settings" element={<PrivateRoute icon={<BalanceTwoTone />} label={"Account_types_settings"}><Accounttypes /></PrivateRoute>} />
<Route path="/profilesettings" element={<PrivateRoute icon={<AssignmentInd />} label={"Profile Settings"}><ProfileSettings /></PrivateRoute>} />
<Route path="/promocodes" element={<PrivateRoute icon={<Discount />} label={"Promocodes"}><Promocodes /></PrivateRoute>} />
<Route path="/available_banks" element={<PrivateRoute icon={<BalanceTwoTone />} label={"Available Banks"}><AvailableBanks /></PrivateRoute>} />
<Route path="/site-settings" element={<PrivateRoute icon={<AssignmentInd />} label={"Site Settings"}><SiteSettings /></PrivateRoute>} />
<Route path="/payment-settings" element={<PrivateRoute icon={<AssignmentInd />} label={"Payment Settings"}><PaymentSettings /></PrivateRoute>} />
<Route path="/business-settings" element={<PrivateRoute icon={<AssignmentInd />} label={"Business Settings"}><BusinessSettings /></PrivateRoute>} />
<Route path="/change-password" element={<PrivateRoute icon={<AssignmentInd />} label={"Change Password"}><ChangePassword /></PrivateRoute>} />
<Route path="/legal-settings" element={<PrivateRoute icon={<AssignmentInd />} label={"Legal Settings"}><LegalSettings /></PrivateRoute>} />
<Route path="/terms-conditions" element={<PrivateRoute icon={<AssignmentInd />} label={"Terms & Condition"}><Termsandcondition /></PrivateRoute>} />
<Route path="/privacy-policy" element={<PrivateRoute icon={<AssignmentInd />} label={"Privacy Policy"}><PrivacyPolicy /></PrivateRoute>} />
<Route path="/settings" element={<PrivateRoute icon={<SettingsSuggest />} label={"Settings"}><Settings /></PrivateRoute>} />
<Route path="/foundation" element={<PrivateRoute icon={<SettingsSuggest />} label={"Foundation"}><Foundation /></PrivateRoute>} />
<Route path="/test-page" element={<PrivateRoute label={"Test page"}><TestPage /></PrivateRoute>} />

<Route path="/dashboard_hotel" element={<HotelPrivateRoute icon={<Dashboard />} label={"Dashboard"}><DashboardHotel /></HotelPrivateRoute>} />
<Route path="/profilesettings_hotel" element={<HotelPrivateRoute icon={<AssignmentInd />} label={"Profile Settings"}><ProfileSettings /></HotelPrivateRoute>} />
<Route path="/mytrips_hotel" element={<HotelPrivateRoute icon={<AssignmentInd />} label={"Mytrips Settings"}><MytripsHotel /></HotelPrivateRoute>} />
<Route path="/upcomingtrips_hotel" element={<HotelPrivateRoute icon={<AssignmentInd />} label={"Upcomingtrips Settings"}><UpcomingtripsHotel /></HotelPrivateRoute>} />


<Route path="/dashboard_corporate" element={<PrivateRoute icon={<Dashboard />} label={"Dashboard"}><Dashboardcorporate /></PrivateRoute>} />
<Route path="/corporate_group" element={<PrivateRoute icon={<Dashboard />} label={"Corporate Group"}><Corporategroup /></PrivateRoute>} />
<Route path="/corporate_employee" element={<PrivateRoute icon={<Dashboard />} label={"Corporate Employee"}><CorporateEmployee /></PrivateRoute>} />
<Route path="/overallreport_corp" element={<PrivateRoute icon={<Assessment />} label={"Overall Report"}><OverallreportCorp /></PrivateRoute>} />
<Route path="/dailytripreport_corp" element={<PrivateRoute icon={<Assessment />} label={"Daily Report"}><DailyreportCorp /></PrivateRoute>} />
<Route path="/monthlytripreport_corp" element={<PrivateRoute icon={<Assessment />} label={"Monthly Report"}><MontlyreportCorp /></PrivateRoute>} />
<Route path="/yearlytripreport_corp" element={<PrivateRoute icon={<Assessment />} label={"Yearly Report"}><YearlyreportCorp /></PrivateRoute>} />


<Route path="/403" element={<PageForbidden />} />
<Route path="/*" element={<PageNotFound />} />

        </Routes>
      </ScrollToTop>
    </BrowserRouter>
  );
};

export default Router;
